import React, { useState } from "react";
import { getCookie } from "../../utils/cookies";
import axios from "axios";
import { Button } from "react-bootstrap";
import { X } from "react-bootstrap-icons";
import { Modal } from "react-bootstrap";
import AlertDialog from "../../ui/alerts/AlertDialog";
import { BACKGROUND_CHECK_STATUS } from "../../constants/ BACKGROUND_CHECK_STATUS";

export default function RejectProvider({ id, handleSuccess }) {
  // Confirm Modal state
  const [showReject, setShowReject] = useState(false);

  // Show and Hide Confirm Modal
  const handleClose = () => setShowReject(false);
  const handleShow = () => setShowReject(true);

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  // Success Dialog State
  const [showSuccess, setShowSuccess] = useState(false);

  // Error Dialog State
  const [showError, setShowError] = useState(false);

  // Deletes a Provider
  const updateApprovalStatus = async (id: number) => {
    try {
      const JWT = await getCookie("ea1-auth");
      const { data: ud } = await axios(
        `https://ea1-dev.azurewebsites.net/api/userServiceProviderDetail/${id}`,
        {
          method: "PATCH",
          data: {
            background_check_status: BACKGROUND_CHECK_STATUS.REJECTED,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: JWT,
          },
        }
      );
      await axios(
        `https://ea1-dev.azurewebsites.net/api/userServiceProviderApprovals/${id}`,
        {
          method: "PATCH",
          data: {
            approved: false,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: JWT,
          },
        }
      );

      if (ud) {
        handleSuccess({ ...ud, approved: false });
      }
      setData(data);
      setIsLoading(false);

      // Confirmation Modal Hide State
      setShowReject(false);

      // Success Alert Popup
      setShowSuccess(true);
    } catch (e) {
      setIsLoading(false);

      // Confirmation Modal Hide State
      setShowReject(false);

      // Error Alert Popup
      setShowError(true);
    }
  };

  const rejectModal = (
    <Modal show={showReject} backdrop='static' onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Reject Provider</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to reject this Provider? This process cannot be
        undone.
      </Modal.Body>
      <Modal.Footer>
        <Button variant='outline-dark' onClick={handleClose}>
          Cancel
        </Button>
        <Button
          type='submit'
          variant='danger'
          onClick={() => updateApprovalStatus(id)}
        >
          Reject
        </Button>
      </Modal.Footer>
    </Modal>
  );

  const successAlert = (
    <Modal
      show={showSuccess}
      onHide={() => {
        setShowSuccess(false);
      }}
      backdrop='static'
    >
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#00E676" }}
      ></Modal.Header>
      <AlertDialog
        title={"Success!"}
        message={"Provider successfully rejected."}
      />
    </Modal>
  );

  const errorAlert = (
    <Modal
      show={showError}
      onHide={() => {
        setShowError(false);
      }}
      backdrop='static'
    >
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#FF1744" }}
      ></Modal.Header>
      <AlertDialog
        title={"Error!"}
        message={"There was an error rejecting this Provider."}
      />
    </Modal>
  );

  return (
    <>
      <Button variant='outline-danger' onClick={handleShow}>
        <X size={25} />
        Reject
      </Button>
      {rejectModal}
      {successAlert}
      {errorAlert}
    </>
  );
}
